import { render, staticRenderFns } from "./LeaveRequests.vue?vue&type=template&id=7c56c624"
import script from "./LeaveRequests.vue?vue&type=script&lang=js"
export * from "./LeaveRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports